import React, { useEffect } from 'react';

import { Divider, Grid } from 'core/components/library';

import {
    Text,
    Button,
    Select,
    Switch,
    Tabs,
    Documents,
    Combo,
    Tag,
    DataGridPro as DataGrid,
    Document
} from 'core/components';

import * as enums from 'core/enums';
import * as icons from 'core/icons';
import List from '../../../../store/List';
import DetailMarca from '../../Marcas/Detalle';
import DetailExplotacion from '../../Explotaciones/Detalle';

import Caracteristicas from './Tabs/TabCaracteristicas';
import Versiones from './Tabs/TabVersiones';
import { statesEntity } from 'core/enums';
import * as helpers from '../../../../core/helpers';
import {
    ENTITY_EXPLOTACION_BODEGA,
    ENTITY_MARCA
} from '../../../../store/entities/constants';
import * as hlprs from '../../../../core/components/helpers';

const ComboMarcas = List(Combo, 'options', 'lstMarcas');
const ComboExplotaciones = List(Combo, 'options', 'lstExplotaciones');

let timeBoxCodigo = 0;

const Etiqueta = props => {
    const {
        values,
        editing,
        adding,
        handleChange,
        refresh,
        reload,
        related,
        execAction
    } = props;

    useEffect(() => {
        if (
            editing &&
            values &&
            values.explotacion &&
            values.explotacion.regEmbotellado
        ) {
            handleChange([
                helpers.getValueControl(
                    'text',
                    'regEmbotellado',
                    values.explotacion.regEmbotellado
                )
            ]);
        }
    }, [JSON.stringify(values.explotacion)]);

    useEffect(() => {
        if (editing) {
            const changes = [];

            if (values.marca) {
                changes.push(
                    helpers.getValueControl(
                        'text',
                        'acronimo',
                        values.marca.acronimo + '-'
                    )
                );

                handleChange(changes);
            }
        }
    }, [JSON.stringify(values.marca)]);

    const actualizaCodigo = () => {
        if (editing) {
            const action = () => {
                const accion = {
                    api: 'etiquetasmarca/nexts',
                    metodo: 'post',
                    data: {
                        fields: ['nombre'],
                        values: { ...values }
                    }
                };
                execAction(accion, [reload]);
            };

            timeBoxCodigo > 0 && clearTimeout(timeBoxCodigo);
            timeBoxCodigo = setTimeout(action, 250);
        }
    };

    return (
        <form autoComplete='off' noValidate>
            <Grid container spacing={1}>
                <Grid item xs>
                    <ComboMarcas
                        fullWidth
                        required
                        api={
                            values.explotacion && values.explotacion.bodega
                                ? `marcasbodega/bodega/${values.explotacion.bodega.id}`
                                : 'marcasbodega/'
                        }
                        name='marca'
                        nameKey='marcaId'
                        label='Marca'
                        relacionado={{
                            api: 'marcasbodega/',
                            type: ENTITY_MARCA,
                            maxWidth: 'lg',
                            Detail: DetailMarca,
                            resume: ['nombre'],
                            dfault:
                                values.explotacion && values.explotacion.bodega
                                    ? {
                                          bodega: {
                                              id: values.explotacion.bodega.id
                                          }
                                      }
                                    : undefined,
                            readOnly: false
                        }}
                        refresh={refresh}
                        Icon={icons.BrandsIcon}
                        value={values.marca}
                        onChange={handleChange}
                        editing={editing}
                        propertyValue='id'
                        getOptionLabel={option => option.nombre}
                        searchKeys={['nombre']}
                    />
                </Grid>
                <Grid item xs>
                    <Text
                        required
                        fullWidth
                        name='nombre'
                        label='Identificador'
                        value={values.nombre}
                        onChange={handleChange}
                        editing={editing}
                        type={`p${values.acronimo ? values.acronimo : ''}.5`}
                        nextValue={adding && actualizaCodigo}
                    />
                </Grid>
                <Grid item>
                    <Switch
                        label='Obsoleta'
                        value={values.obsoleta}
                        onChange={handleChange}
                        name='obsoleta'
                        editing={editing}
                    />
                </Grid>
                <Grid item xs>
                    <Tag
                        variant={'outline'}
                        align={'center'}
                        size={'medium'}
                        sx={{
                            color: enums.getItem(
                                statesEntity,
                                values.estado,
                                'color'
                            )
                        }}
                        Icon={enums.getItem(
                            statesEntity,
                            values.estado,
                            'icon'
                        )}
                        value={values.estado}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1}>
                {!related && (
                    <Grid item xs>
                        <ComboExplotaciones
                            required
                            fullWidth
                            api={`explotaciones/bodega/${values.marca && values.marca.bodega ? values.marca.bodega.id : ''}`}
                            name='explotacion'
                            nameKey='explotacionId'
                            label='Centro'
                            relacionado={{
                                api: 'explotaciones/',
                                type: ENTITY_EXPLOTACION_BODEGA,
                                maxWidth: 'lg',
                                Detail: DetailExplotacion,
                                resume: ['nombre'],
                                readOnly: false
                            }}
                            refresh={refresh}
                            Icon={icons.SitesIcon}
                            value={values.explotacion}
                            onChange={handleChange}
                            editing={editing}
                            propertyValue='id'
                            getOptionLabel={option =>
                                `${option.codigo}-${option.nombre}-[${option.bodega.nombre}]`
                            }
                            searchKeys={['codigo', 'nombre', 'bodega.nombre']}
                        />
                    </Grid>
                )}
                <Grid item xs>
                    <Text
                        fullWidth
                        label='Descripción / Resumen'
                        editing={editing}
                        name='resumen'
                        value={values.resumen}
                        //onFocus={event => event.target.select()}
                        onChange={handleChange}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={1}>
                <Grid item xs>
                    <Grid container direction={'column'} spacing={1}>
                        <Grid item xs>
                            <Grid container spacing={1}>
                                <Grid item xs>
                                    <Text
                                        fullWidth
                                        label='Fecha Verificación'
                                        editing={editing}
                                        name='fecha'
                                        type='datetime-local'
                                        value={hlprs.getValueFormatted(
                                            'datetime-local',
                                            values.fecha
                                        )}
                                        //onFocus={event => event.target.select()}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <Text
                                        fullWidth
                                        label='Num. Registro'
                                        editing={editing}
                                        name='registro'
                                        value={values.registro}
                                        //onFocus={event => event.target.select()}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <Text
                                        fullWidth
                                        label='Idioma'
                                        editing={editing}
                                        name='idioma'
                                        value={values.idioma}
                                        //onFocus={event => event.target.select()}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs>
                                    <Text
                                        fullWidth
                                        editing={editing}
                                        label='Destino'
                                        name='destino'
                                        value={values.destino}
                                        //onFocus={event => event.target.select()}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs>
                            <Text
                                fullWidth
                                multiline
                                rows={3}
                                name='notas'
                                label='Notas'
                                value={values.notas}
                                onChange={handleChange}
                                editing={editing}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={2}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%'
                        }}
                    >
                        <Document
                            name='enlace'
                            readOnly={!editing}
                            width='100px'
                            height='100px'
                            value={values.enlace}
                            onChange={handleChange}
                        />
                    </div>
                </Grid>
            </Grid>

            <Tabs
                tabs={[
                    {
                        label: 'Detalles',
                        icon: icons.DetailIcon,
                        component: <Caracteristicas {...props} />,
                        hide: false
                    },
                    /*{
                        label: 'Versiones',
                        icon: icons.VersionsIcon,
                        component: <Versiones {...props} />
                    },*/
                    {
                        label: 'Documentos',
                        icon: icons.DocumentIcon,
                        component: (
                            <Documents
                                name='documentacion'
                                editing={editing}
                                onChange={handleChange}
                                rows={
                                    values.documentacion
                                        ? values.documentacion
                                        : []
                                }
                                minHeight={456}
                                maxHeight={456}
                            />
                        ),
                        disabled: false
                    }
                ]}
            />
        </form>
    );
};

export default Etiqueta;
